/* eslint-disable @typescript-eslint/no-namespace */
import { IBrandFeatures } from '../models';

export namespace FeatureActions {
  /**
   * Action to initialize the features from the brand input
   *
   * @export
   * @class Init
   */
  export class Init {
    public static readonly type = '[Feature] Load Brand Features';
    constructor(public brand: string, public stage: string) {}
  }

  /**
   * Action to add a new feature relative to the brand currently in execution
   *
   * @export
   * @class Add
   */
  export class Add {
    public static readonly type = '[Feature] Add Brand Features';
    constructor(public features: IBrandFeatures) {}
  }
}
